import script from "./PropertyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyCard.vue?vue&type=script&setup=true&lang=js"

import "./PropertyCard.vue?vue&type=style&index=0&id=376ff675&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-376ff675"]])

export default __exports__